export default {
  leave: {
    crud: {
      create: "Add Time Off Request"
    },
    menu: {
      leave_accruals: "Time Off Accruals",
      leave_requests: "Time Off Requests",
      leave_approvals: "Pending Time Off Approvals"
    },
    hourly: "Hourly",
    daily: "Daily",
    type: "Time Off Type",
    begin_time: "Begin Time",
    end_time: "End Time",
    begin_date: "Begin Date",
    end_date: "End Date",
    approved_time: "Approved Date",
    request_time: "Request Time",
    approve_or_reject: "Approve or Reject",
    status: "Status",
    no_approver: "No Approver",
    manager: "Time Off Manager",
    managers: "Time Off Managers",
    balance: "Balance",
    not_leave_accruals: "This employee has not yet deserved a time off",
    permission: {
      employee_leave_approver_message: "This staff member can approve requests for permission from other staff",
      employee_not_leave_approver_message: "This staff member cannot approve permission requests from other staff",
      employee_shift_approver_message: "This staff member can assign shifts to other staff",
      employee_not_shift_approver_message: "This staff member cannot assign shifts to other staff",
      employee_overtime_approver_message: "This staff member can approve overtime requests from other staff",
      employee_not_overtime_approver_message: "This staff member cannot approve overtime requests from other staff"
    },
    notification: {
      employee_receiver_leave_notification_message:
        "These personnel may receive permission notices from other personnel",
      employee_not_receiver_leave_notification_message: "This staff cannot receive permission notices from other staff",
      employee_receiver_shift_notification_message:
        "These staff can receive shift assignment notifications from other staff",
      employee_not_receiver_shift_notification_message:
        "This staff cannot receive shift assignment notifications from other staff",
      employee_receiver_overtime_notification_message:
        "These staff can receive overtime request notifications from other staff",
      employee_not_receiver_overtime_notification_message:
        "This staff cannot receive overtime request notifications from other staff"
    },
    respect: "Permission managers above will have priority",
    order_is_important: "The manager's order is important",
    already_selected_manager: "You have already selected this manager",
    there_is_no_leave_manager: "No assigned time off managers",
    add_leave_manager: "Add Time Off Manager",
    used: "Used",
    remaining: "Remaining",
    on_leave: "On Time Off",
    period: "Period",
    duration: "Duration",
    periods: {
      first_half: "1.Half",
      second_half: "2.Half",
      first_quarter: "1.Quarter",
      second_quarter: "2.Quarter",
      third_quarter: "3.Quarter",
      fourth_quarter: "4.Quarter"
    },
    request: {
      this_day_does_not_count_as_leave: "This day does not count as time off",
      leave_balance: "Time Off Balance ",
      max_exceed_leave_balance: "Max Exceed Time Off Balance",
      leave_request_count: "Time Off Request Count",
      used: "Used",
      remaining: "Remaining",
      approved: "Approve",
      denied: "Deny",
      leave_decreased_count: "Time Off will decrease",
      requested_leave_type_documents: "Required document for time off",
      required_document_message:
        " | There is {count} document you need to upload | There are {count} documents you need to upload"
    },
    accruals: {
      name: "Name",
      count: "Count",
      used: "Used",
      previous_balance: "Previous Balance"
    },
    approvals: {
      leave_approval: "Time Off Approval",
      message:
        "Do you want to approve the employee named <b>{0}</b> to use a total of <b>{3}</b> days of time off named <b>{4}</b> between <b>{1}</b> - <b>{2}</b>?"
    },
    cancels: {
      leave_cancel: "Cancel Time Off",
      message: "Your reason for revoking the time off?",
      error_message: "Your reason for canceling? space is required"
    },
    error_messages: {
      notice_period_error: "This time off must be requested at least {0} days in advance",
      max_consecutive_error: "You can request up to {0} days of time off at a time",
      min_consecutive_error: "You can request a minimum of {0} days of time off at a time",
      leave_request_exist_error: "There is a requested time off on these dates",
      total_leave_balance_error1: "You do not have enough balance for this time off",
      total_leave_balance_error2:
        "For this time off, you can use a maximum of {0} days from the advance balance, you can not request time off because your advance balance is insufficient.",
      leave_balance_error1: "Because you don't have enough balance",
      leave_balance_error2: "day advance will be deducted from your balance"
    },
    e_signature: "E-signature",
    e_signature_leave_form: "E-signed Time Off Form",
    leave_form: "Time Off Form",
    leave_cancel: "Cancel Time Off",
    signed: "Signed",
    not_signed: "Not Signed",
    leave_form_name: "time_off_form_"
  },
  leave_request_status: {
    pending: "Pending",
    PENDING: "Pending",
    approved: "Approved",
    APPROVED: "Approved",
    denied: "Denied",
    DENIED: "Denied",
    cancelled: "Cancelled",
    CANCELLED: "Cancelled",
    need_extra_detail: "Need extra detail",
    NEED_EXTRA_DETAIL: "Need extra detail",
    null: "Unknown",
    NULL: "Unknown",
    undefined: "Unknown",
    UNDEFINED: "Unknown",
    closed: "Closed",
    CLOSED: "Closed"
  },
  time_duration: {
    hour: "Hour",
    minute: "Minute",
    second: "Second"
  },
  leave_type: {
    paid: "Paid",
    unpaid: "Unpaid",
    on_duty: "On Duty",
    restricted_holiday: "Restricted Holiday"
  },
  leave_status: {
    APPROVED: "Approved",
    PENDING: "Pending",
    DENIED: "Denied",
    CANCELLED: "Cancelled",
    NEED_EXTRA_DETAIL: "Need Extra Detail",
    not_come: "No time has come",
    NOT_COME: "No time has come"
  },
  leave_duration: {
    FULL_DAY: "Full Day",
    HALF_DAY: "Half Day",
    QUARTER_DAY: "Quarter Day",
    HOURLY_DAY: "Hourly Day",
    HOURLY: "Hourly"
  },
  documentVisibleByHR:
    "With this upload, I understand and consent that the document will be visible by HR, Time & Attendance and Payroll OPS team and your Team Manager."
};
